export default __webpack_public_path__ + "static/media/j41.327aef8e.jpg";